import { useState } from "react";
import AuthInputs from "./components/AuthInputs";
import BrownSubmit from "../../buttons/BrownSubmit";
// import { invalidEmailMessage } from "~/services/validation/authValidation";
// import { useRouter } from "next/router";
// import { clientCookieSet } from "../../../services/cookies";
import { changePassword } from "../../../services/cms/auth";
import passwordValidator from "password-validator";
import MailIcon from "../../icons/auth_inputs/mail.svg";
import { useRouter } from "next/router";


// const SignupForm = ({ setError, setVisible }) => {
const SignupForm = ({ setError, setVisible }) => {
  //redux learning only ^
  const router = useRouter();
  const [email, setEmail] = useState();

  //   const router = useRouter();

  const schemaEmail = new passwordValidator();

  schemaEmail.has(["@"]);

  const onSubmitForm = async (event) => {
    event.preventDefault();

    const fullData = {
      email: email.toLowerCase(),
    };
    const validatedEmail = schemaEmail.validate(email, { list: true });

    if (validatedEmail.length === 0) {
      const response = await changePassword(fullData);
      if (response.status === 200) {
        alert(
          "If we have an account associated with that email address, we will send an email about changing the password.",
        );
        //setVisible(true);
        router.push("/login");
      }

      // TODO: create a json of error codes
    } else if (validatedEmail.length > 0) {
      if (validatedEmail.length > 0) {
        setError("Please provide a valid email.");
        setVisible(true);
      }
    }
  };

  return (
    <form className="auth__form" noValidate onSubmit={(e) => onSubmitForm(e)}>
      {/* TODO noValidate temp measure, figure out why form isn't working */}

      <AuthInputs
        label="Email"
        value={email}
        setValue={setEmail}
        type="text"
        imageAlt="mail icon"
        imageURL={MailIcon}
        htmlFor="email"
        placeholder="Email"
      />

      <BrownSubmit
        paddingUpDown={20}
        paddingLeftRight={158}
        type="submit"
        content="Submit Email"
        onSubmit={onSubmitForm}
      />
    </form>
  );
};

export default SignupForm;
